import React from 'react';

import { FormikErrors } from 'formik';

import Skeleton from '../Skeleton/Skeleton';

import { UpdateContractInput } from '@/pages/ContractDetails/ContractHeaders/hooks/useUpdateContract';
import { Input, InputChange } from '../InputTag4/InputTag4';
import styles from './contract-header.module.scss';

type ErrorMessage = string | string[] | FormikErrors<any> | FormikErrors<any>[] | undefined;
interface IContractHeaderItemProps {
  label: string,
  value?: string | number;
  defaultValue?: string | number;
  isLoading?: boolean,
  center?: boolean,
  disabled?: boolean,
  onSubmit?: (input: UpdateContractInput) => void
  type?: string;
  name?: string
  title?: string
  inputStyle?: React.CSSProperties;
  errorMessage?: ErrorMessage;
  onChange?: ((e: InputChange) => void)
  step?: string;
  loadingLabel?: boolean;
  labelSuffix?: React.ReactNode;
}

type FocusEvent = React.FocusEvent<HTMLInputElement, Element>;

export default function ContractHeaderInputItem({
  label,
  value,
  isLoading,
  disabled,
  onSubmit,
  inputStyle,
  type,
  name,
  title,
  errorMessage,
  onChange,
  step,
  loadingLabel,
  labelSuffix,
}: IContractHeaderItemProps): JSX.Element {
  const handleSubmit = (e: FocusEvent) => {
    if (e.target?.name && (e.target?.value || e.target?.value === '') && !errorMessage) {
      onSubmit?.({ [e.target.name]: e.target.value });
    }
  };

  return (
    <div
      className={styles['contract-header']}
    >
      {loadingLabel && isLoading ? (
        <Skeleton count={1} width={150} />)
        : (<span className={styles.label}>{label}{labelSuffix}</span>)}
      {isLoading && (
        <Skeleton count={1} />
      )}
      {!isLoading && (
        <div className={styles['contract-header-input']} title={title}>
          <Input
            disabled={disabled}
            style={inputStyle}
            type={type}
            onBlur={handleSubmit}
            name={name}
            onChange={onChange}
            value={value}
            step={step}
          />
        </div>)}
    </div>
  );
}
